module.exports = "./img/f05eb63440959b5289012ed7174098d8.png";